import { render, staticRenderFns } from "./ModulesView.vue?vue&type=template&id=717e7bf0&"
import script from "./ModulesView.vue?vue&type=script&lang=js&"
export * from "./ModulesView.vue?vue&type=script&lang=js&"
import style0 from "./ModulesView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports